module.exports = __webpack_public_path__ + "static/media/proactive-instance.72db3958.png";